import * as Sentry from '@sentry/sveltekit';
import { handleErrorWithSentry } from '@sentry/sveltekit';
import type { ClientInit } from '@sveltejs/kit';
import { configureApi } from '@voicedojo/api';
import { apiOrigin, ApiError, isAccountMoving, setApiOrigin } from '$lib/api/client';
import { resolveCellOrigin } from '$lib/api/cellProbe';
import { toastUnhandledRejection } from '$lib/api/rejectionToast';
import { toastWhileLiveUpdatesPaused } from '$lib/api/hubConnection';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN ?? '';
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    release: import.meta.env.VITE_APP_VERSION ?? '0.0.0-dev',
    environment: import.meta.env.VITE_BUILD_CHANNEL ?? 'dev',
    tracesSampleRate: 0,
    integrations: [],
  });
}

export const handleError = handleErrorWithSentry();

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    toastUnhandledRejection(reason);
    if (reason instanceof ApiError) {
      event.preventDefault();
      if (sentryDsn && (reason.status >= 500 || reason.status === 0) && !isAccountMoving(reason)) Sentry.captureException(reason);
    }
  });
}

toastWhileLiveUpdatesPaused();

// SvelteKit awaits this before the first page loads, so nothing dials before the cell is known.
export const init: ClientInit = async () => {
  const origin = await resolveCellOrigin();
  if (origin !== undefined) setApiOrigin(origin);
  configureApi({ baseUrl: apiOrigin() });

  // Memoized with the root layout's call: one whoami.
  void import('$lib/stores/auth').then(({ bootstrapAuth }) => bootstrapAuth());
};
